import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'AJOUT_ETAB',
  title: 'Comment inscrire mes autres établissements ? ',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous possédez plusieurs établissements, ils peuvent également déposer leurs documents sur la plateforme. Il suffit de suivre les étapes ci-dessous :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquez en haut à gauche sur le nom de votre entreprise et affichez le menu déroulant'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_ETAB/FR_AJOUT_ETAB_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez ensuite sur « Sélectionner une entreprise »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_ETAB/FR_AJOUT_ETAB_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Ensuite, renseignez le numéro de SIRET de l’établissement que vous souhaitez ajouter et cliquez sur « Continuer »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_ETAB/FR_AJOUT_ETAB_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Si votre établissement n’est pas présent sur la plateforme, renseignez toutes les informations demandées.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_ETAB/FR_AJOUT_ETAB_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Une fois que les informations sont renseignées, votre demande de rajout est en cours de traitement. Vous serez ensuite notifié par email.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_ETAB/FR_AJOUT_ETAB_5.png`
  }]
};
